import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'open_with_faire-owf_grant_page_cta_clicks-click';

/**
 * Track CTA clicks for the OWF Grant flow
 */
export function trackOpenWithFaireOwfGrantPageCtaClicksClick(
  CtaClick_string: string,
  Page_string2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { CtaClick_string, Page_string2 },
  });
}
